import { fbt } from 'fbtee'
import { suggestEventLabel } from '../../lib/commonStrings'
import type { BrowseType } from './browseType'

// Per-type localized strings for the Discover page. fbt needs literal
// text+desc, so each variant is spelled out rather than interpolated.
export interface BrowseStrings {
  discoverEmpty: string
  suggestLabel: string
}

export function browseStrings(type: BrowseType): BrowseStrings {
  switch (type) {
    case 'festival':
      return {
        discoverEmpty: fbt(
          'No upcoming festivals.',
          'Empty state on the festivals page when there are no upcoming festivals',
        ),
        suggestLabel: fbt('Suggest a festival', 'Button label to suggest a festival be added'),
      }
    case 'party':
      return {
        discoverEmpty: fbt(
          'No upcoming parties.',
          'Empty state on the parties page when there are no upcoming parties',
        ),
        suggestLabel: fbt('Suggest a party', 'Button label to suggest a party be added'),
      }
    case 'all':
      return {
        discoverEmpty: fbt(
          'No upcoming events.',
          'Empty state on the Discover page when there are no upcoming festivals or parties',
        ),
        suggestLabel: suggestEventLabel(),
      }
  }
}
